import React from 'react';

interface ThreeColumnHeadingProps {
    headingSize?: `small` | `medium` | `large`;
    children?: React.ReactElement | string;
}

type HeadingTagSelectType = `h1` | `h2` | `h3` | `h4` | `h5` | `h6`;

export const ThreeColumnHeading: React.FC<ThreeColumnHeadingProps> = ({
    headingSize,
    children,
}) => {
    if (!children) return null;
    if (!headingSize) headingSize = `small`;

    enum HeadingTagSize {
        small = `h3`,
        medium = `h5`,
        large = `h3`,
    }

    const HeadingTagSelect = HeadingTagSize[
        headingSize
    ] as HeadingTagSelectType;

    return <HeadingTagSelect>{children}</HeadingTagSelect>;
};